module.exports = __webpack_public_path__ + "static/media/asterisk.9a97e4d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/assets/asterisk.svg
// module id = 243
// module chunks = 241 242 243